import { render, staticRenderFns } from "./modalDetalleCarga.vue?vue&type=template&id=0fbf9f30&scoped=true&"
import script from "./modalDetalleCarga.vue?vue&type=script&lang=js&"
export * from "./modalDetalleCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf9f30",
  null
  
)

export default component.exports